module.exports = __webpack_public_path__ + "img/viewpoint-animate2.48173dd8.png";